import { HashLink } from "../../../../src/components/link";
import * as React from 'react';
export default {
  HashLink,
  React
};